import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_isNode() {
  _init_properties_is_node_kt__dnpdf7();
  var tmp0 = isNode$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('isNode', 0, tmp, _get_isNode_$ref_4joeoi(), null);
  return tmp0.get_value_j01efc_k$();
}
var isNode$delegate;
function isNode$delegate$lambda() {
  _init_properties_is_node_kt__dnpdf7();
  var tmp = typeof process !== 'undefined' && process.versions != null && process.versions.node != null || (typeof window !== 'undefined' && typeof window.process !== 'undefined' && window.process.versions != null && window.process.versions.node != null);
  return (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : THROW_CCE();
}
function _get_isNode_$ref_4joeoi() {
  return constructCallableReference(() => get_isNode(), 0, 0, 227);
}
var properties_initialized_is_node_kt_9kjm2d;
function _init_properties_is_node_kt__dnpdf7() {
  if (!properties_initialized_is_node_kt_9kjm2d) {
    properties_initialized_is_node_kt_9kjm2d = true;
    isNode$delegate = lazy(isNode$delegate$lambda);
  }
}
//region block: exports
export {
  get_isNode as get_isNodeu9kqlebvup92,
};
//endregion

//# sourceMappingURL=is-node.mjs.map
